import { evolutiveCrossService } from 'src/services/evolutiveCross';
import AnalyzeService from '../../services/analyze';

// TODO: remove temp
import fake from './fake1.json';

// actions
export const STORE_AUTO_CORRELATION_CONFIG = 'STORE_AUTO_CORRELATION_CONFIG';
export const FETCH_AUTO_CORRELATION_CONFIG = 'FETCH_AUTO_CORRELATION_CONFIG';
export const STORE_MULTI_CROSS_CONFIG = 'STORE_MULTI_CROSS_CONFIG';
export const FETCH_MULTI_CROSS_CONFIG = 'FETCH_MULTI_CROSS_CONFIG';
export const UPDATE_MULTI_CROSS_CONFIG = 'UPDATE_MULTI_CROSS_CONFIG';
export const FIND_MULTI_CROSS_CONFIG = 'FIND_MULTI_CROSS_CONFIG';
export const REMOVE_MULTI_CROSS_CONFIG = 'REMOVE_MULTI_CROSS_CONFIG';
export const STORE_CORRELATION_CONFIG = 'STORE_CORRELATION_CONFIG';
export const FETCH_CORRELATION_CONFIG = 'FETCH_CORRELATION_CONFIG';
export const REMOVE_CORRELATION_CONFIG = 'REMOVE_CORRELATION_CONFIG';
export const FIND_CORRELATION_CONFIG = 'FIND_CORRELATION_CONFIG';
export const UPDATE_CORRELATION_CONFIG = 'UPDATE_CORRELATION_CONFIG';
export const CREATE_EVOLUTIVO_CONFIG = 'CREATE_EVOLUTIVO_CONFIG';
export const LIST_EVOLUTIVO_CONFIG = 'LIST_EVOLUTIVO_CONFIG';
export const LIST_EVOLUTIVE_CROSS_CONFIG = 'LIST_EVOLUTIVE_CROSS_CONFIG';
export const FETCH_EVOLUTIVO_RESULT = 'FETCH_EVOLUTIVO_RESULT';
export const SELECT_EVOLUTIVO_CONFIG = 'SELECT_EVOLUTIVO_CONFIG';
export const REMOVE_EVOLUTIVO_CONFIG = 'REMOVE_EVOLUTIVO_CONFIG';
export const FIND_EVOLUTIVO_CONFIG = 'FIND_EVOLUTIVO_CONFIG';
export const UPDATE_EVOLUTIVO_CONFIG = 'UPDATE_EVOLUTIVO_CONFIG';
export const FETCH_SIMULATION_CONFIG = 'FETCH_SIMULATION_CONFIG';
export const CREATE_EVOLUTIVE_CROSS_CONFIG = 'CREATE_EVOLUTIVE_CROSS_CONFIG';
export const FETCH_EVOLUTIVE_CROSS_RESULT = 'FETCH_EVOLUTIVE_CROSS_RESULT';

/**
 * action: salva os dados de configuração automática de correlação
 *
 * config = {
 *  customerId,   // id do cliente
 *  surveyId,     // id da pesquisa
 *  minMaxCorrValue, // nota de corte da correlação
 * }
 *
 * @param {*} config
 * @param {*} dispatch
 */
export function storeAutoCorrelationConfig(config, dispatch) {
  const service = new AnalyzeService();
  const { customerId, surveyId, minMaxCorrValue } = config;
  const dataPromise = service.storeAutoCorrConfig(customerId, surveyId, minMaxCorrValue);
  dispatch({ type: STORE_AUTO_CORRELATION_CONFIG, payload: dataPromise });
}

/**
 * action: salva os dados de configuração automática de correlação
 *
 * config = {
 *  customerId,   // id do cliente
 *  surveyId,     // id da pesquisa
 *  minMaxCorrValue, // nota de corte da correlação
 * }
 *
 * @param {*} config
 * @param {*} dispatch
 */
export function updateCorrelationConfig(configId, configData, dispatch) {
  const service = new AnalyzeService();
  const { customerId, surveyId, title, questionsIds, mainAnswer, minMaxCorrValue } = configData;
  const dataPromise = service.updateCorrelationConfig(customerId, surveyId, configId, title, questionsIds, mainAnswer, minMaxCorrValue);
  dispatch({ type: UPDATE_CORRELATION_CONFIG, payload: dataPromise });
}

/**
 * action: salva os dados de configuração de cruzamento multiplos
 *
 * config = {
 *  customerId,   // id do cliente
 *  surveyId,     // id da pesquisa
 *  title,        // título
 *  questionsIds, // array de ids de perguntas da pesquisa
 *  profiles,     // array de um objeto com id de perguntas e de respostas {questionId,answerId}
 * }
 *
 * @param {*} config
 * @param {*} dispatch
 */
export function storeMultCrossingConfig(config, dispatch) {
  const service = new AnalyzeService();
  const { customerId, surveyId, title, profiles, questionsIds } = config;
  const dataPromise = service.storeMultCrossConfig(customerId, surveyId, title, questionsIds, profiles);
  dispatch({ type: STORE_MULTI_CROSS_CONFIG, payload: dataPromise });
}

/**
 * action: atualizar os dados de configuração de cruzamento multiplos
 *
 * config = {
 *  customerId,   // id do cliente
 *  surveyId,     // id da pesquisa
 *  title,        // título
 *  questionsIds, // array de ids de perguntas da pesquisa
 *  profiles,     // array de um objeto com id de perguntas e de respostas {questionId,answerId}
 * }
 *
 * @param {*} config
 * @param {*} dispatch
 */
export function updateMultCrossingConfig(configId, configData, dispatch) {
  const service = new AnalyzeService();
  const { customerId, surveyId, title, profiles, questionsIds } = configData;
  const dataPromise = service.updateMultCrossConfig(customerId, surveyId, configId, title, questionsIds, profiles);
  dispatch({ type: UPDATE_MULTI_CROSS_CONFIG, payload: dataPromise });
}

/**
 *
 * @param {*} surveyId
 * @param {*} customerId
 * @param {*} dispatch
 */
export function fetchMultCrossConfigs(clientId, surveyId, questionId, dispatch) {
  const service = new AnalyzeService();
  const dataPromise = service.listMultCrossConfigs(clientId, surveyId, questionId);
  dispatch({ type: FETCH_MULTI_CROSS_CONFIG, payload: dataPromise, meta: { clientId, surveyId, questionId }});
}

/**
 *
 * @param {*} surveyId
 * @param {*} customerId
 * @param {*} dispatch
 */
export function findMultCrossingConfig(customerId, surveyId, questionId, configId, dispatch) {
  const service = new AnalyzeService();
  const dataPromise = service.findMultCrossConfigs(customerId, surveyId, questionId, configId);
  dispatch({ type: FIND_MULTI_CROSS_CONFIG, payload: dataPromise });
}

/**
 *
 * @param {*} surveyId
 * @param {*} customerId
 * @param {*} configId
 * @param {*} dispatch
 */
export function removeMultCrossConfig(customerId, surveyId, questionId, configId, dispatch) {
  const service = new AnalyzeService();
  const dataPromise = new Promise((resolve, reject) => {
    service.removeMultCrossConfig(customerId, surveyId, configId).then(() => {
      service.listMultCrossConfigs(customerId, surveyId, questionId).then((resp) => {
        resolve(resp);
      }).catch((e) => reject(e));
    }).catch((e) => reject(e));
  });
  dispatch({ type: REMOVE_MULTI_CROSS_CONFIG, payload: dataPromise });
}

/**
 * action: salva os dados de configuração de cruzamento multiplos
 *
 * config = {
 *    customerId,       // id do cliente
 *    surveyId,         // id da pesquisa
 *    title,            // titulo da configuração -
 *    questionsIds,     // ids das perguntas que cujas alternativas serão relacionadas com a resposta selecionada acima
 *    mainAnswer: {     // resposta principal que será correlacionada com as perguntas abaixo.
 *     questionId: number;
 *     alternativeId: number;
 *    }
 *    minMaxCorrValue,  // nota de corta, que deve ser um valor absoluto entre 0 e 1.
 * }
 * @param {*} config
 * @param {*} dispatch
 */
export function storeCorrelationConfig(config, dispatch) {
  const service = new AnalyzeService();
  const { customerId, surveyId, title, questionsIds, mainAnswer, minMaxCorrValue } = config;
  const dataPromise = service.storeCorrelationConfig(customerId, surveyId, title, questionsIds, mainAnswer, minMaxCorrValue);
  dispatch({ type: STORE_CORRELATION_CONFIG, payload: dataPromise });
}

/**
 *
 * @param {*} surveyId
 * @param {*} customerId
 * @param {*} dispatch
 */
export function fetchCorrelationConfigs(surveyId, customerId, questionId, dispatch) {
  const service = new AnalyzeService();
  const dataPromise = service.listCorrelationConfigs(customerId, surveyId, questionId);
  dispatch({ type: FETCH_CORRELATION_CONFIG, payload: dataPromise });
}

/**
 *
 * @param {*} surveyId
 * @param {*} customerId
 * @param {*} dispatch
 */
export function findCorrelationConfig(customerId, surveyId, questionId, configId, dispatch) {
  const service = new AnalyzeService();
  const dataPromise = service.findCorrelationConfig(customerId, surveyId, questionId, configId);
  dispatch({ type: FIND_CORRELATION_CONFIG, payload: dataPromise });
}

/**
 *
 * @param {*} surveyId
 * @param {*} customerId
 * @param {*} configId
 * @param {*} dispatch
 */
export function removeCorrConfig(customerId, surveyId, questionId, configId, dispatch) {
  const service = new AnalyzeService();
  const dataPromise = new Promise((resolve, reject) => {
    service.removeCorrConfig(customerId, surveyId, configId).then(() => {
      service.listCorrelationConfigs(customerId, surveyId, questionId).then((resp) => {
        resolve(resp);
      }).catch((e) => reject(e));
    }).catch((e) => reject(e));
  });
  dispatch({ type: REMOVE_CORRELATION_CONFIG, payload: dataPromise });
}

/**
 * dispara uma action que realiza o cadastro de uma configuracao de evolutivo
 *
 * @param {*} clientId
 * @param {*} surveyId
 * @param {*} questionId
 * @param {*} title
 * @param {*} othersSurveys
 * @param {*} alternativeMatchs
 * @param {*} dispatch
 */
export function storeEvolutiveConfig(clientId, surveyId, questionId, title, othersSurveys, alternativeMatchs, dispatch) {
  const service = new AnalyzeService();
  const promise = service.storeEvolutiveConfig(clientId, surveyId, questionId, title, othersSurveys, alternativeMatchs);
  dispatch({ type: CREATE_EVOLUTIVO_CONFIG, payload: promise });
}

/**
 * dispara uma action que realiza o cadastro de uma configuracao de evolutivo de cruzamentos
 * 
 * @param {*} clientId 
 * @param {*} surveyId 
 * @param {*} payload 
 */
export function storeEvolutiveCrossConfig(
  clientId,
  surveyId,
  payload,
  dispatch,
  onSuccess,
  onError
) {
  const promise = evolutiveCrossService.createConfig(clientId, surveyId, payload);
  
  promise
    .then(() => onSuccess())
    .catch(() => onError());

  dispatch({ type: CREATE_EVOLUTIVE_CROSS_CONFIG, payload: promise });
}

/**
 * dispara uma action que realiza a alteração do cadastro de uma configuracao de evolutivo
 *
 * @param {*} clientId
 * @param {*} surveyId
 * @param {*} questionId
 * @param {*} title
 * @param {*} othersSurveys
 * @param {*} alternativeMatchs
 * @param {*} dispatch
 */
export function updateEvolutiveConfig(clientId, surveyId, questionId, configId, title, othersSurveys, alternativeMatchs, dispatch) {
  const service = new AnalyzeService();
  const promise = service.updateEvolutiveConfig(clientId, surveyId, questionId, configId, title, othersSurveys, alternativeMatchs);
  dispatch({ type: UPDATE_EVOLUTIVO_CONFIG, payload: promise });
}

/**
 * dispara uma action que realiza a listagem das configuracoes de evolutivo
 *
 * @param {*} clientId id do cliente que possuira a configuracao
 * @param {*} surveyId id da pesquisa que possui a configuracao
 */
export function findEvolutiveConfig(clientId, surveyId, questionId, configId, dispatch) {
  const service = new AnalyzeService();
  const promise = service.findEvolutiveConfig(clientId, surveyId, questionId, configId);
  dispatch({ type: FIND_EVOLUTIVO_CONFIG, payload: promise });
}

/**
 * dispara uma action que realiza a listagem das configuracoes de evolutivo
 *
 * @param {*} clientId id do cliente que possuira a configuracao
 * @param {*} surveyId id da pesquisa que possui a configuracao
 */
export function listEvolutiveConfigs(clientId, surveyId, questionId, dispatch) {
  const service = new AnalyzeService();
  const promise = service.listEvolutiveConfigs(clientId, surveyId, questionId);
  dispatch({ type: LIST_EVOLUTIVO_CONFIG, payload: promise, meta: { clientId, surveyId, questionId }});
}

/**
 * dispara uma action que realiza a listagem das configuracoes de evolutivo de cruzamentos
 *
 * @param {*} clientId id do cliente que possuira a configuracao
 * @param {*} surveyId id da pesquisa que possui a configuracao
 */
 export function listEvolutiveCrossConfigs(clientId, surveyId, questionId, dispatch) {
  const promise = evolutiveCrossService.listConfigs(clientId, surveyId, questionId);
  dispatch({ type: LIST_EVOLUTIVE_CROSS_CONFIG, payload: promise, meta: { clientId, surveyId, questionId }});
}

/**
 *
 * @param {*} surveyId
 * @param {*} customerId
 * @param {*} configId
 * @param {*} dispatch
 */
export function removeEvolutiveConfig(customerId, surveyId, questionId, configId, dispatch) {
  const service = new AnalyzeService();
  const dataPromise = new Promise((resolve, reject) => {
    service.removeEvolutiveConfig(customerId, surveyId, configId).then(() => {
      service.listEvolutiveConfigs(customerId, surveyId, questionId).then((resp) => {
        resolve(resp);
      }).catch((e) => reject(e));
    }).catch((e) => reject(e));
  });
  dispatch({ type: REMOVE_EVOLUTIVO_CONFIG, payload: dataPromise });
}

/**
 * dispara uma action que seleciona uma configuração do evolutivo
 * presente na listagem de configurações.
 *
 * @param {*} idConfig identificador da configuração a ser selecionada
 */
export function selectEvolutiveConfig(idConfig, dispatch) {
  dispatch({ type: SELECT_EVOLUTIVO_CONFIG, payload: idConfig });
}

/**
 * dispara uma action que realiza o fetch de resultados de uma configuracao
 * de evolutivo
 *
 * @param {*} configId id da configuracao do cruzamento
 */
export function fetchEvolutiveConfigResult(configId, dispatch) {
  const service = new AnalyzeService();
  const promise = service.fetchEvolutiveConfigResult(configId);
  dispatch({ type: FETCH_EVOLUTIVO_RESULT, payload: promise, meta: { configId }});
}

export function fetchEvolutiveCrossConfigResult(configId, crossedQuestionId, alternativeId, dispatch) {
  const promise = evolutiveCrossService.fetchConfigResult(configId, crossedQuestionId, alternativeId);
  dispatch({ type: FETCH_EVOLUTIVE_CROSS_RESULT, payload: promise, meta: { configId }});
}

/**
 *
 * @param {*} surveyId
 * @param {*} customerId
 * @param {*} dispatch
 */
export function fetchSimulationConfigs(customerId, surveyId, questionId, dispatch) {
  // TODO: resolver a listagem da configuração da simulação
  // const service = new AnalyzeService();
  // const dataPromise = service.listMultCrossConfigs(customerId, surveyId, questionId);
  // dispatch({ type: FETCH_MULTI_CROSS_CONFIG, payload: dataPromise });
  const dataPromise = new Promise((resolve) => {
    resolve({ data: fake });
  });
  dispatch({ type: FETCH_SIMULATION_CONFIG, payload: dataPromise });
}

/**
 *
 * @param {*} surveyId
 * @param {*} customerId
 * @param {*} configId
 * @param {*} dispatch
 */
export function removeSimulationConfig(customerId, surveyId, questionId, configId, dispatch) {
  // TODO: resolver a remoção da configuração da simulação
  // const service = new AnalyzeService();
  // const dataPromise = new Promise((resolve, reject) => {
  //   service.removeMultCrossConfig(customerId, surveyId, configId).then(() => {
  //     service.listMultCrossConfigs(customerId, surveyId, questionId).then((resp) => {
  //       resolve(resp);
  //     }).catch((e) => reject(e));
  //   }).catch((e) => reject(e));
  // });
  // dispatch({ type: REMOVE_MULTI_CROSS_CONFIG, payload: dataPromise });
}
